import { createTRPCProxyClient, httpLink } from '@trpc/client'
import superjson from 'superjson'
import type { PublicIdentityRouter, JwtIdentityRouter } from '@weapps/identity/faces'
import { getIdentityServiceUrl } from './config/runtime'

// Public face (/public): unauthenticated broker — login, signup, refresh, federatedCallback, etc.
export const publicClient = createTRPCProxyClient<PublicIdentityRouter>({
  transformer: superjson,
  links: [httpLink({ url: `${getIdentityServiceUrl()}/public` })],
})

// JWT face (/private): edge-JWT-authenticated — establishSession, profile reads/writes. Carries the
// current ID token as a bearer; the API Gateway validates it (trust-gateway in-process).
export function jwtClient(token: string | null) {
  return createTRPCProxyClient<JwtIdentityRouter>({
    transformer: superjson,
    links: [
      httpLink({
        url: `${getIdentityServiceUrl()}/private`,
        headers: () => (token ? { Authorization: `Bearer ${token}` } : {}),
      }),
    ],
  })
}
